import { render, staticRenderFns } from "./detail-mahasiswa.vue?vue&type=template&id=49c5b7b8&scoped=true&"
import script from "./detail-mahasiswa.vue?vue&type=script&lang=js&"
export * from "./detail-mahasiswa.vue?vue&type=script&lang=js&"
import style0 from "./detail-mahasiswa.vue?vue&type=style&index=0&id=49c5b7b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5b7b8",
  null
  
)

export default component.exports